/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Rag_Desc3Inputs */

const en_svc_ai_integration_rag_desc3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer over your own data with grounded sources, citations, and fresh content, no hallucinations on stale docs.`)
};

const ar_svc_ai_integration_rag_desc3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجابة على بياناتك الخاصة بمصادر حقيقية وتوثيقات ومحتوى جديد, لا هلوسات على وثائق قديمة.`)
};

const bn_svc_ai_integration_rag_desc3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার নিজের ডেটা দিয়ে উত্তর দিন, গ্রাউন্ডেড সোর্স, সাইটেশন ও ফ্রেশ কনটেন্টসহ, পুরনো ডক্সে হ্যালুসিনেশন নয়।`)
};

const de_svc_ai_integration_rag_desc3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantworten Sie Fragen über Ihre eigenen Daten mit fundierten Quellen, Zitaten und frischen Inhalten, ohne Halluzinationen über veraltete Dokumente.`)
};

const es_svc_ai_integration_rag_desc3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responda sobre sus propios datos con fuentes fundamentadas, citas y contenido nuevo, sin alucinaciones sobre documentos obsoletos.`)
};

const fr_svc_ai_integration_rag_desc3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répondez à vos propres données avec des sources fondées, des citations et du contenu récent, sans hallucinations sur des documents obsolètes.`)
};

const pt_svc_ai_integration_rag_desc3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responda sobre seus próprios dados com fontes fundamentadas, citações e conteúdo novo, sem alucinações com documentos obsoletos.`)
};

const zh_svc_ai_integration_rag_desc3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于您自己的数据作答，来源可靠、带引用、内容新鲜，陈旧文档也不幻觉。`)
};

const tr_svc_ai_integration_rag_desc3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temelli kaynaklarla, alıntılarla ve yeni içerikle kendi verileriniz üzerinden yanıt verin, eski belgelerle ilgili halüsinasyonlar yaşamayın.`)
};

const ru_svc_ai_integration_rag_desc3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отвечайте на основе своих данных: обоснованные источники, цитаты и свежий контент, без галлюцинаций по устаревшим докам.`)
};

const pl_svc_ai_integration_rag_desc3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpowiadaj na podstawie własnych danych, korzystając z ugruntowanych źródeł, cytatów i świeżej treści, bez halucynacji związanych z nieaktualnymi dokumentami.`)
};

/**
* | output |
* | --- |
* | "Answer over your own data with grounded sources, citations, and fresh content, no hallucinations on stale docs." |
*
* @param {Svc_Ai_Integration_Rag_Desc3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_rag_desc3 = /** @type {((inputs?: Svc_Ai_Integration_Rag_Desc3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Rag_Desc3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_rag_desc3(inputs)
	if (locale === "bn") return bn_svc_ai_integration_rag_desc3(inputs)
	if (locale === "de") return de_svc_ai_integration_rag_desc3(inputs)
	if (locale === "es") return es_svc_ai_integration_rag_desc3(inputs)
	if (locale === "fr") return fr_svc_ai_integration_rag_desc3(inputs)
	if (locale === "pt") return pt_svc_ai_integration_rag_desc3(inputs)
	if (locale === "zh") return zh_svc_ai_integration_rag_desc3(inputs)
	if (locale === "tr") return tr_svc_ai_integration_rag_desc3(inputs)
	if (locale === "ru") return ru_svc_ai_integration_rag_desc3(inputs)
	if (locale === "pl") return pl_svc_ai_integration_rag_desc3(inputs)
	return en_svc_ai_integration_rag_desc3(inputs)
});
export { svc_ai_integration_rag_desc3 as "svc_ai-integration_RAG_desc" }